import { ResponseService } from './response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Cart } from '../interfaces/cart/cart.model';
import { AuthService } from './auth.service';
import { toSubscriber } from 'rxjs/internal-compatibility';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';

/**
 * TODO Finalize full service for shopping cart and other thinks, right now simple version will by used directly on module
 */
@Injectable()
export class CartService {

    public cart: String;
    public cartForLoged: String;
    public positions: any;

    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private localStorageService: LocalStorageService,
        private authService: AuthService,
        private router: Router,
    ) { }

    setCart(cartUuid) {
        this.clearCart();
        this.localStorageService.set('cart', cartUuid);
        return this.checkIsActiveCart();
    }

    removeCart(cartUuid){
        return this.apiService.delete(`/shopping-cart/${cartUuid}`);
    }

    getDashboardData(cartUuid){
        return this.apiService.get(`/shopping-cart/${cartUuid}`);
    }

    checkIsActiveCart() {
        this.cart = this.localStorageService.get('cart', null);
        if (this.cart) {
            const isLoged = this.authService.isAuth().toPromise().then((auth) => {
                if (auth) {
                    return Promise.resolve(true);
                }
                return Promise.resolve(false);
            });
            return this.checkCartRequest().toPromise().then(cartOk => {
                if(!cartOk){
                    this.clearCart();
                }
                return Promise.resolve(cartOk);
            }, (response) => {
                if(response.status.message == 'shopping-cart.checked'){
                    return true;
                }
                this.clearCart();
                return false;
            });
        }
        return false;
    }

    checkCartRequest() {
        return this.apiService.get(`/check-client-cart/${this.cart}`)
            .map((response) => {
                if (response.status.message == 'shopping-cart.checked') {
                    return true;
                }
                return false;
            }, (error) => {
                return false;
            });
    }

    clearCart() {
        this.cart = null;
        this.localStorageService.set('cart', null);
    }

    assignCartToClient() {
        this.apiService.post(`/shopping-cart`, this.cart).subscribe(response => {
            if (response.data.message == 'cart.saved') {
                this.cart = response.data.cart;
            }
        });
    }

    getAllCarts(active: Boolean = true){
        return this.apiService.get(`/shopping-cart/${active ? 'active' : 'finalized'}`);
    }

    storeCartPosition(forService, service, quantity, type) {
        this.apiService.post(`/shopping-cart/${(this.checkIsActiveCart() ? this.cart : 'new-cart')}/item`, { parent: forService, quantity: quantity, type: type, service: service }).subscribe(response => {
            if (response.status && response.status.code == 200) {
                this.cart = response.data.cart;
                this.localStorageService.set('cart', this.cart);
                this.responseService.success(true, response);
                service.selectedValue = service.min;
                return;
            }
            this.responseService.error(response);
        }, error => {
            if (error.status.code == 404 && error.status.message == 'shopping-cart.not_found') {
                this.localStorageService.set('cart', null);
                this.storeCartPosition(forService, service, quantity, type);
                return;
            }
            this.responseService.error(error);
        });
    }

    storeCartVPSs(selectedConfigurations)
    {
        this.apiService.post(`/shopping-cart/${(this.checkIsActiveCart() ? this.cart : 'new-cart')}/vps`, {selectedConfigurations: selectedConfigurations}).subscribe(response => {
            if (response.status && response.status.code == 200) {
                this.cart = response.data.cart;
                this.localStorageService.set('cart', this.cart);
                this.responseService.success(true, response);
                this.router.navigateByUrl('/service/offer/company');
                return;
            }
            this.responseService.error(response);
        }, error => {
            if (error.status.code == 404 && error.status.message == 'shopping-cart.not_found') {
                this.localStorageService.set('cart', null);
                this.storeCartVPSs(selectedConfigurations);
                return;
            }
            this.responseService.error(error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cart.service.ts